import {EmployeeOnboardingSnapshot, OnboardingStandard, OnboardingTraining} from 'app/services/employee-onboarding.service';

export type OnboardingPanel = 'onboarding' | 'probation' | 'head';
export const ONBOARDING_PANEL = {ONBOARDING: <OnboardingPanel>'onboarding', PROBATION: <OnboardingPanel>'probation',
  HEAD: <OnboardingPanel>'head'};
const COMPANY = 0;
const DEPARTMENT = 1;
const SUBDEPARTMENT = 2;
const AFFILIATE_TYPE = 'AFFILIATE';
const DEPARTMENT_TYPE = 'DEPARTMENT';
const COMPANY_TITLE = 'ONBOARDING_STEP_COMPANY';
const DEPARTMENT_TITLE = 'ONBOARDING_STEP_DEPARTMENT';
const SUBDEPARTMENT_TITLE = 'ONBOARDING_STEP_SUBDEPARTMENT';
const AFFILIATE_TRAINING = 'PROBATION_TRAINING_AFFILIATE';
const COMPANY_TRAINING = 'PROBATION_TRAINING_COMPANY';
const OTHER_TRAINING = 'PROBATION_TRAINING_OTHER';
const DEPARTMENT_TRAINING = 'PROBATION_TRAINING_DEPARTMENT';
const AFFILIATE_STEP = 2;
const COMPANY_STEP = 3;
const DEPARTMENT_STEP = 4;
const EXTRA_STEP = 0;

export interface OnboardingStandardStep { priority: number; title: string; standards: OnboardingStandard[]; }
export interface OnboardingTrainingGroup {
  step: number; title: string; trainings: OnboardingTraining[]; completed: number; requiredCount: number;
}

export function onboardingFinished(snapshot: EmployeeOnboardingSnapshot): boolean {
  return !!snapshot && !!(snapshot.onboardingCompletedAt || snapshot.onboardingHistoricallySkipped);
}

export function onboardingVisible(snapshot: EmployeeOnboardingSnapshot, now: number): boolean {
  if (!snapshot || snapshot.onboardingHistoricallySkipped) { return false; }
  return !snapshot.onboardingCompletedAt || Date.parse(snapshot.onboardingVisibleUntil) > now;
}

export function probationVisible(snapshot: EmployeeOnboardingSnapshot, now: number): boolean {
  if (!snapshot) { return false; }
  return !snapshot.approved || Date.parse(snapshot.probationVisibleUntil) > now;
}

export function headTrainingVisible(snapshot: EmployeeOnboardingSnapshot): boolean {
  return !!snapshot && (snapshot.headTrainings || []).some(training => training.currentLevel < training.requiredLevel);
}

export function startingSteps(snapshot: EmployeeOnboardingSnapshot): OnboardingStandardStep[] {
  const standards = snapshot.startingStandards || [];
  return [{priority: COMPANY, title: COMPANY_TITLE}, {priority: DEPARTMENT, title: DEPARTMENT_TITLE},
    {priority: SUBDEPARTMENT, title: SUBDEPARTMENT_TITLE}]
    .map(step => ({priority: step.priority, title: step.title,
      standards: standards.filter(standard => standard.pinPriority === step.priority)}))
    .filter(step => step.priority !== SUBDEPARTMENT || !!step.standards.length);
}

export function trainingGroups(snapshot: EmployeeOnboardingSnapshot): OnboardingTrainingGroup[] {
  const courses = snapshot.trainings || [];
  return [
    {step: AFFILIATE_STEP, title: AFFILIATE_TRAINING, trainings: courses.filter(course => course.companyRequired
      && course.ownerGroupType === AFFILIATE_TYPE)},
    {step: COMPANY_STEP, title: COMPANY_TRAINING, trainings: courses.filter(course => course.companyRequired
      && course.ownerGroupType === DEPARTMENT_TYPE)},
    {step: EXTRA_STEP, title: OTHER_TRAINING, trainings: courses.filter(course => course.companyRequired
      && course.ownerGroupType !== AFFILIATE_TYPE && course.ownerGroupType !== DEPARTMENT_TYPE)},
    {step: DEPARTMENT_STEP, title: DEPARTMENT_TRAINING, trainings: courses.filter(course => !course.companyRequired)}
  ].filter(group => group.step !== EXTRA_STEP || !!group.trainings.length)
    .map(group => summarizeTrainingGroup(group, courses));
}

function summarizeTrainingGroup(group: {step: number; title: string; trainings: OnboardingTraining[]},
                                courses: OnboardingTraining[]): OnboardingTrainingGroup {
  const required = group.step === DEPARTMENT_STEP
    ? courses.filter(course => !course.companyRequired || !!course.departmentSources && !!course.departmentSources.length)
    : group.trainings;
  return {...group, requiredCount: required.length,
    completed: required.filter(course => course.currentLevel >= course.requiredLevel).length};
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/employee-onboarding/employee-onboarding-view.ts